import {http} from '../core/http';

export interface SearchFilesParams {
  obskey?: string;
  keywords?: string;
  tags?: string[];
  page_size: number;
  page_index: number;
}

export const searchService = {
  searchFiles(params: SearchFilesParams) {
    return http.post('/uss/get_files', params);
  },

  recentSearchFiles(params: { limit: number }) {
    return http.post('/uss/get_query_logs', params);
  },

  clearRecentSearch() {
    return http.post('/uss/delete_query_logs', {});
  },
};